import { render, staticRenderFns } from "./tiktokpay.vue?vue&type=template&id=47d8e434"
import script from "./tiktokpay.vue?vue&type=script&lang=js"
export * from "./tiktokpay.vue?vue&type=script&lang=js"
import style0 from "./tiktokpay.vue?vue&type=style&index=0&id=47d8e434&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports